import React,{Fragment} from 'react';

import CollapseMenu from './CollapseMenu'
import SingleMenu from './SingleMenu'

const Menu = ({item, toggled}) => {
    return ( 
        <>
            <hr className="sidebar-divider" />

            <div className="sidebar-heading" >
                {item.section}
            </div>
            {item.menu.map( menu  => {
                return (
                <Fragment key={menu.nombre}>
                    {menu.subMenu.length === 0 ?
                        <SingleMenu 
                            key={menu.nombre}
                            menu={menu.nombre}
                            link={menu.link}
                            icon={menu.icon}
                            /> : 
                        <CollapseMenu 
                            key={menu.nombre}
                            menu={menu.nombre}
                            icon={menu.icon}
                            subMenu={menu.subMenu}
                            toggled={toggled}
                        />
                    }
                </Fragment>
                )
                })
            }
        </>
     );
}
 
export default Menu;